<template>
  <div>
    <fund-selector @fund-selected="onFundSelected($event)" />
    <missing-fund-reports-list
      v-if="selectedFund"
      ref="missingReportsList"
      :fundId="selectedFund.key"
      @addReport="addReport($event)"
    />

    <a-drawer
      title="Add Monthly Report"
      width="600"
      placement="right"
      :visible="showAddReportDrawer"
      @close="onAddReportDrawerClosed()"
    >
      <add-fund-monthly-report
        :fund="selectedFund"
        :classes="selectedFundClasses"
        :selectedYear="selectedYear"
        :selectedMonth="selectedMonth"
        @reportSaved="onReportAdded($event)"
        @cancelButtonClicked="showAddReportDrawer = false"
      />
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import AddFundMonthlyReport from '../components/FundReporting/AddFundMonthlyReport.vue'
import FundSelector from '../components/FundReporting/FundSelector.vue'
import MissingFundReportsList from '../components/FundReporting/MissingReportsList.vue'

export default {
  components: {
    AddFundMonthlyReport,
    FundSelector,
    MissingFundReportsList,
  },
  apollo: {
    funds: {
      client: 'funds',
      query: gql`
        query {
          funds {
            id
            key
            name
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      funds: [],
      selectedFund: null,
      selectedFundClasses: [],
      selectedReport: null,
      showAddReportDrawer: false,
    }
  },
  computed: {
    reportDrawerTitle() {
      if (!this.selectedReport) {
        return ''
      }
      if (!this.selectedFund) {
        return ''
      }
      return `${this.selectedFund.name} - ${this.selectedReport.year}/${this.selectedReport.month}`
    },
    selectedYear() {
      return this.selectedReport ? this.selectedReport.year : null
    },
    selectedMonth() {
      return this.selectedReport ? this.selectedReport.month : null
    },
  },
  methods: {
    onFundSelected(payload) {
      this.selectedFund = payload.fund
      this.selectedFundClasses = payload.classes
    },
    addReport(report) {
      this.selectedReport = report
      this.showAddReportDrawer = true
    },
    onAddReportDrawerClosed() {
      this.showAddReportDrawer = false
    },
    onReportAdded() {
      this.showAddReportDrawer = false
      this.$refs.missingReportsList.reloadReports()
    },
  },
}
</script>

<style></style>
